import axios from "@/config/axios";

// In-flight requests map to prevent duplicate concurrent calls for the same path
const inFlightRequests = {};

const state = {
  // Store multiple presigned URLs, keyed by image path
  downloadUrlMap: {},  // e.g., { "test-tube-images/NASALSWAB.png": "https://..." }
};

const mutations = {
  SET_DOWNLOAD_URL(state, { path, url }) {
    state.downloadUrlMap[path] = url;
  },
};

const actions = {
  fetchDownloadUrl: async ({ commit, state }, path) => {
    // Return cached URL if already resolved
    if (state.downloadUrlMap[path]) {
      return state.downloadUrlMap[path];
    }
    // Return in-flight promise if a request is already in progress for this path
    if (inFlightRequests[path]) {
      return inFlightRequests[path];
    }
    inFlightRequests[path] = axios.post("/presigned-url", { path })
      .then((response) => {
        if (response.data.success && response.data.data) {
          commit("SET_DOWNLOAD_URL", { path, url: response.data.data });
          return response.data.data;
        }
      })
      .catch((error) => {
        console.error("Failed to fetch download URL", error);
      })
      .finally(() => {
        delete inFlightRequests[path];
      });
    return inFlightRequests[path];
  },
};

const getters = {
  getDownloadUrlByPath: (state) => (path) => {
    return state.downloadUrlMap[path];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
